import type { DateFormat } from '@luna/date';

import type { PfmCountryFeatureConfig } from './type';

export const pfmFeatureConfig: PfmCountryFeatureConfig = {
    dateFormat: {
        monthYearLong: 'yyyy. LLLL' as DateFormat,
        monthYearShort: 'yy/MM' as DateFormat,
        dayOrdinalMonthLong: 'MMMM do' as DateFormat,
    },
};
